import { render, staticRenderFns } from "./PaletteFeature.vue?vue&type=template&id=64e2b709&scoped=true&"
import script from "./PaletteFeature.vue?vue&type=script&lang=ts&"
export * from "./PaletteFeature.vue?vue&type=script&lang=ts&"
import style0 from "./PaletteFeature.vue?vue&type=style&index=0&id=64e2b709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2b709",
  null
  
)

component.options.__file = "PaletteFeature.vue"
export default component.exports